import api from "@/plugins/api/EntryPoint";

export default {
  async createDistributionOrderCherkasy(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-cherkasy/create-distribution-order-cherkasy",
      params,
      callBackFn
    );
  },
  async createDistributionToOrderCherkasy(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-cherkasy/create-distribution-to-order-cherkasy",
      params,
      callBackFn
    );
  },
  async getCherkasyAccountDistributionDebt(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-cherkasy/get-cherkasy-account-distribution-debt",
      params,
      callBackFn
    );
  },
};
